
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perfil/configuracion/busquedas",
      function () {
        return require("private-next-pages/perfil/configuracion/busquedas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/perfil/configuracion/busquedas"])
      });
    }
  